/* eslint-disable no-unused-vars */
import { Grid, CircularProgress } from "@mui/material";
import PConfirm from "../../../../components/pos/PConfirm";
import PDialog from "../../../../components/pos/PDialog";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../../utils/API";
import { StringUtils } from "../../../../utils/StringUtils";
import QuickPurchaseRequestList from "./QuickPurchaseRequestList.jsx";
import QuickPurchaseRequestOrderDetails from "./QuickPurchaseRequestOrderDetails.jsx";
import QuickPurchaseRequestSummary from "./QuickPurchaseRequestSummary.jsx";
import db from "../../../../db/db";

export default function QuickPurchaseRequestWindow(props) {
  const { t } = useTranslation();
  const translate = t;
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitile] = useState("New quick purchase order");
  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [purchaseItems, setPurchaseItems] = useState([]);
  const [taxType, setTaxType] = useState({ name: "Include Tax", id: "1" });
  const [taxTypeOptions, setTaxTypeOptions] = useState([]);
  const [amount, setAmount] = useState("");
  const [errorAmount, setErrorAmount] = useState("");
  const [roundoffAmount, setRoundffAmount] = useState("");
  const [discountTypeOptions, setDiscountTypeOptions] = useState([
    { name: "After Tax", id: "1" },
    { name: "Before Tax", id: "2" },
  ]);

  const [summary, setSummary] = useState(getDefaultSummar());

  const [purchaseOrderObj, setPurchaseOrderObj] = useState();
  const [returnFlag, setReturnFlag] = useState(false);
  const [showProgressDialog, setShowProgressDialog] = useState(false);
  const [progressMessage, setProgressMessage] = useState("");
  const [liveValidation, setLiveValidation] = useState(false);

  //const [costAccountMappingList, setCostAccountMappingList] = useState([]);
  const [selectedVendor, setSelectedVendor] = useState(null);
  const [costCalculationType, setCostCalculationType] = useState({
    name: "Cost from Received Cost",
    id: "COST_FROM_RECEIVED_COST",
  });
  const [costCalculationTypeOptions, setCostCalculationTypeOptions] = useState([
    {
      name: "Cost from Received Cost",
      id: "COST_FROM_RECEIVED_COST",
    },
    { name: "Cost from Final Cost", id: "COST_FROM_FINAL_COST" },
  ]);

  var biRef = {};

  props.biRef.quickEntry = {
    showQuickPurchaseRequestWindow: showQuickPurchaseRequestWindow,
  };

  function showQuickPurchaseRequestWindow(purchaseorderId, type, isReturn) {
    setOpenWindow(true);
    setReturnFlag(isReturn);
    if (purchaseorderId == null) {
      setMode("create");
      resetFields();
      if (isReturn) {
        if (
          localStorage.getItem("purchaseReturnTaxType") &&
          localStorage.getItem("purchaseReturnTaxType") != ""
        ) {
          setTaxType(JSON.parse(localStorage.getItem("purchaseReturnTaxType")));
        }

        if (
          localStorage.getItem("purchaseReturnCostCalculationType") &&
          localStorage.getItem("purchaseReturnCostCalculationType") != ""
        ) {
          setCostCalculationType(
            JSON.parse(
              localStorage.getItem("purchaseReturnCostCalculationType")
            )
          );
        }

        if (
          localStorage.getItem("purchaseReturnOrderLineItems") &&
          localStorage.getItem("purchaseReturnOrderLineItems") != ""
        ) {
          console.log("##4");

          setPurchaseItemsWrapper(
            JSON.parse(localStorage.getItem("purchaseReturnOrderLineItems"))
          );
        }
        setWindowTitile(" " + translate("Goods return voucher"));
      } else {
        if (
          localStorage.getItem("purchaseOrderCostCalculationType") &&
          localStorage.getItem("purchaseOrderCostCalculationType") != ""
        ) {
          setCostCalculationType(
            JSON.parse(localStorage.getItem("purchaseOrderCostCalculationType"))
          );
        }

        if (
          localStorage.getItem("purchaseOrderTaxType") &&
          localStorage.getItem("purchaseOrderTaxType") != ""
        ) {
          setTaxType(JSON.parse(localStorage.getItem("purchaseOrderTaxType")));
        }

        if (
          localStorage.getItem("purchaseOrderLineItems") != null &&
          localStorage.getItem("purchaseOrderLineItems") != undefined &&
          localStorage.getItem("purchaseOrderLineItems") != ""
        ) {
          let cache = JSON.parse(
            localStorage.getItem("purchaseOrderLineItems")
          );
          let newArr = [];
          for (let d of cache) {
            let r = [];
            let j = 0;
            for (let rr of d) {
              if (j == 4) {
                if (rr == null) {
                  r.push({
                    v: {
                      foc: false,
                      focQty: 0,
                    },
                  });
                } else {
                  r.push(rr);
                }
              } else {
                r.push(rr);
              }
              j++;
            }
            newArr.push(r);
          }
          console.log("##3");

          setPurchaseItemsWrapper(newArr);
        }
        setWindowTitile(" " + translate("Goods receive note"));
      }
    } else {
      if (type == "View") {
        setWindowTitile(
          translate("View Purchase") +
            (isReturn ? " " + translate("return") : " " + translate("order"))
        );
        setMode("view");
      } else {
        setWindowTitile(
          translate("Edit Purchase") +
            (isReturn ? " " + translate("return") : " " + translate("order")) +
            translate(" settlement")
        );
        setMode("edit");
      }
      populatePurchaseOrder(purchaseorderId);
    }
  }

  function onCloseWindow() {
    resetFields();
    setOpenWindow(false);
  }

  function isDataChanged() {
    return false;
  }

  useEffect(() => {
    setTaxTypeOptions([
      { name: "Include Tax", id: "1" },
      { name: "Exclude Tax", id: "2" },
      { name: "No Tax", id: "3" },
    ]);
  }, []);

  useEffect(() => {
    if (
      purchaseItems != null &&
      purchaseItems.length > 0 &&
      mode != null &&
      mode != undefined &&
      mode != "view"
    ) {
      if (mode == "create") {
        if (returnFlag) {
          localStorage.setItem(
            "purchaseReturnOrderLineItems",
            JSON.stringify(purchaseItems)
          );
        } else {
          localStorage.setItem(
            "purchaseOrderLineItems",
            JSON.stringify(purchaseItems)
          );
        }
      }
    }
  }, [purchaseItems]);

  useEffect(() => {
    if (taxType && mode && mode != "view") {
      if (mode == "create") {
        if (returnFlag) {
          localStorage.setItem(
            "purchaseReturnTaxType",
            JSON.stringify(taxType)
          );
        } else {
          localStorage.setItem("purchaseOrderTaxType", JSON.stringify(taxType));
        }
      }
    }
  }, [taxType]);

  useEffect(() => {
    if (costCalculationType && mode && mode != "view") {
      if (mode == "create") {
        if (returnFlag) {
          localStorage.setItem(
            "purchaseReturnCostCalculationType",
            JSON.stringify(costCalculationType)
          );
        } else {
          localStorage.setItem(
            "purchaseOrderCostCalculationType",
            JSON.stringify(costCalculationType)
          );
        }
      }
    }
  }, [costCalculationType]);

  useEffect(() => {
    if (liveValidation && (amount === "" || amount == 0)) {
      setErrorAmount("Required Invoice Amount");
    } else {
      if (amount) {
        setRoundffAmount(
          StringUtils.formattedNumberWithStoreDecimal(
            parseFloat(amount) - parseFloat(summary.finalAmount),
            props.context
          )
        );
      } else {
        setRoundffAmount(
          StringUtils.formattedNumberWithStoreDecimal(0, props.context)
        );
      }
      setErrorAmount("");
    }
  }, [amount]);

  function getDefaultSummar() {
    return {
      qty: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      total: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      totalWoTax: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      totalTax: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      discountType: {
        name: "After Tax",
        id: "1",
      },
      discount: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
      finalAmount: StringUtils.formattedNumberWithStoreDecimal(
        0,
        props.context
      ),
      finalAmountExTax: StringUtils.formattedNumberWithStoreDecimal(
        0,
        props.context
      ),
      finalTax: StringUtils.formattedNumberWithStoreDecimal(0, props.context),
    };
  }

  function resetFields() {
    setPurchaseOrderObj(null);

    setSummary(getDefaultSummar());
    console.log("##2");

    setPurchaseItemsWrapper([]);

    //setCostAccountMappingList([]);
    setSelectedVendor(null);
    if (biRef.requestCrud != undefined)
      biRef.requestCrud.parentEvent("resetFileds");
  }

  async function populatePurchaseOrder(purchaseOrderId) {
    try {
      let { data } = await API.get("/api/v1/purchaseorder/" + purchaseOrderId);
      populateData(data);
      setOpenWindow(true);
    } catch (err) {
      console.log(err);
      props.showMessage(
        "error",
        translate("Not able to retrive purchase order data from server")
      );
    }
  }

  async function populateData(inputData) {
    taxTypeOptions.map((item) => {
      if (item.id == inputData.taxTypeValue) {
        setTaxType(item);
      }
    });
    setPurchaseOrderObj(inputData);

    let costCalculationTypeTemp;
    if (inputData.costCalculationTypeName && inputData.costCalculationTypeId) {
      costCalculationTypeTemp = {
        name: inputData.costCalculationTypeName,
        id: inputData.costCalculationTypeId,
      };
    } else {
      costCalculationTypeTemp = {
        name: "Cost from Received Cost",
        id: "FROM RECEIVED COST",
      };
    }
    let vSummary = getDefaultSummar();
    if (inputData.discountTypeText && inputData.discountTypeValue) {
      vSummary.discountType = {
        name: inputData.discountTypeText,
        id: inputData.discountTypeValue,
      };
    } else {
      vSummary.discountType = {
        name: "After Tax",
        id: "1",
      };
    }

    /*Render summary values*/
    // setSubTotalDiscount(
    //   StringUtils.formattedNumberWithStoreDecimal(
    //     inputData.subTotalDiscountAmount ? inputData.subTotalDiscountAmount : 0,
    //     props.context
    //   )
    // );
    // setShippingCost(
    //   StringUtils.formattedNumberWithStoreDecimal(
    //     inputData.shippingCost ? inputData.shippingCost : 0,
    //     props.context
    //   )
    // );
    // let invoiceAmount = parseFloat(
    //   inputData.invoiceAmount ? inputData.invoiceAmount : 0
    // );
    // setInvoiceAmount(
    //   StringUtils.formattedNumberWithStoreDecimal(invoiceAmount, props.context)
    // );

    // let costAccountMapList = [];
    // if (inputData.shippingCostAccountBeanList) {
    //   inputData.shippingCostAccountBeanList.map((item) => {
    //     costAccountMapList.push({
    //       serialNumber: costAccountMapList.length + 1,
    //       vendorAccount: {
    //         name: item.toAccountLedgerName,
    //         id: item.toAccountLedgerId,
    //       },
    //       invoiceNumber: item.invoiceNumber,
    //       shippingAmount: item.shippingCost,
    //       taxPercentage: item.taxPercentage,
    //       date: item.date,
    //       description: item.description,
    //     });
    //   });
    // }
    // setCostAccountMappingList(costAccountMapList);

    /*Populate table*/
    let sn = 1;
    let data = [];

    for (let item of inputData.orderItems) {
      let productData = [];

      let dbProduct = await db.product
        .where("id")
        .equals(item.productId)
        .toArray();

      if (dbProduct.length == 0) {
        productData = await API.get(
          "/api/v1/product/" + item.productId + "?includeDeleted=true"
        );
      }

      let qty =
        item.receivedQty && parseFloat(item.receivedQty) > 0
          ? item.receivedQty
          : item.quantity && parseFloat(item.quantity) > 0
          ? item.quantity
          : 0;
      let orderItem = [
        { v: sn },
        { v: item.productName },
        { v: item.unitType },
        {
          v: qty,
        },
        { v: { foc: item.isIncludeFocQty, focQty: item.focQty } },
        { v: item.actualCost },
        { v: item.lineItemDiscountAmount ? item.lineItemDiscountAmount : 0 },
        {
          v: item.actualCost * qty,
        },
        { v: item.taxPercentage },
        { v: { name: item.taxTypeText, id: item.taxTypeValue } },
        { v: item.taxCost },
        {
          v:
            item.receivedCostWithoutTax &&
            parseFloat(item.receivedCostWithoutTax) > 0
              ? item.receivedCostWithoutTax
              : 0,
        },
        {
          v:
            item.receivedNetCost && parseFloat(item.receivedNetCost) > 0
              ? item.receivedNetCost
              : 0,
        },
        {
          info: {
            productBean:
              dbProduct.length == 0 ? productData.data : dbProduct[0],
            // productBean: dbProduct.data,
            pricingBean: null,
            selected: false,
            calculationType: costCalculationTypeTemp,
          },
        },
      ];
      data.push(orderItem);
      sn++;
    }
    console.log("##1");

    setPurchaseItems(data);

    vSummary.discount = inputData.subTotalDiscountAmount;
    updateSummary(data, vSummary);

    setAmount(inputData.amount);
    setRoundffAmount(inputData.roundoffAmount);
  }

  function showProgress(flag, message) {
    if (message) {
      setProgressMessage(message);
    }
    setShowProgressDialog(flag);
  }

  async function onSaveDraftClicked() {
    var payload = createPayload("DRAFT");
    if (payload) {
      try {
        showProgress(true, "Saving");
        let result = await API.post("/api/v1/purchaseorder", payload);
        props.showMessage(
          "success",
          translate("Purchase order saved as draft")
        );
        props.onRefresh();
        localStorage.removeItem("purchaseOrderLineItems");
        showQuickPurchaseRequestWindow(
          result.data.id,
          props.context.privileges.grn_grv_draft_edit ? "Edit" : "View",
          returnFlag
        );
        showProgress(false, "Saving");
      } catch (err) {
        showProgress(false, "Saving");
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          props.showMessage(
            "error",
            translate("Not able to Save Purchase Order")
          );
        }
      }
    }
  }

  async function onSave() {
    setConfirmContext({
      title: "Are You Sure",
      message: "Are you sure to post the order,This action can't revert!",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      confirmContextType: "SAVE",
    });
    setConfirmOpen(true);
    /*Save action implemented in function onYesNoClicked*/
  }
  function showDetailedError(msg) {
    if (biRef && biRef.requestCrud)
      biRef.requestCrud.parentEvent("validation", msg);
    props.showMessage("error", msg.message);
  }

  function createPayload(status) {
    let saveObject = null;
    if (status == "DRAFT")
      saveObject = biRef.requestCrud.parentEvent("getDraftPayload");
    else saveObject = biRef.requestCrud.parentEvent("getPayload");
    if (!saveObject) {
      props.showMessage("error", translate("Validation failed"));
      return null;
    }
    if (status == "SETTLED" && purchaseItems.length == 0) {
      props.showMessage("error", translate("No products selected for settle"));
      return null;
    }

    if (amount == "" || amount == 0) {
      props.showMessage("error", translate("Required Invoice Amount"));
      setErrorAmount("Required Invoice Amount");
      setLiveValidation(true);
      return null;
    }

    if (
      roundoffAmount &&
      (parseInt(roundoffAmount) > 1 || parseInt(roundoffAmount) < -1)
    ) {
      props.showMessage(
        "error",
        translate("The rounded amount cannot exceed 1.00")
      );
      return null;
    }

    let invoiceCheckRequired = false;
    if (status == "SETTLED") {
      for (let i = 0; i < purchaseItems.length; i++) {
        let isFocChecked = purchaseItems[i][4] && purchaseItems[i][4].v.foc;
        let origQty =
          purchaseItems[i][3].v === "" ? 0 : parseFloat(purchaseItems[i][3].v);
        let focQty = isFocChecked
          ? parseFloat(
              purchaseItems[i][4].v.focQty === ""
                ? "0"
                : purchaseItems[i][4].v.focQty
            )
          : 0;

        if (origQty > 0) {
          invoiceCheckRequired = true;
        }

        let cost = parseFloat(
          purchaseItems[i][5].v === "" ? "0" : purchaseItems[i][5].v
        );

        if (origQty <= 0 && !isFocChecked) {
          props.showMessage(
            "error",
            "Validation failed, Quantity is required at row" +
              ":" +
              (parseInt(i) + 1).toString()
          );
          return null;
        }
        if (!isFocChecked && cost <= 0) {
          props.showMessage(
            "error",
            "Validation failed, Cost is required at row:" +
              (parseInt(i) + 1).toString()
          );
          return null;
        }
        if (isFocChecked && origQty > 0 && cost <= 0) {
          props.showMessage(
            "error",
            "Validation failed, Cost is required at row:" +
              (parseInt(i) + 1).toString()
          );
          return null;
        }

        if (isFocChecked && focQty <= 0) {
          props.showMessage(
            "error",
            "Validation failed, Foc Qty is required at row:" +
              (parseInt(i) + 1).toString()
          );
          return null;
        }
      }
    }
    saveObject["status"] = status;
    let orderItems = [];
    let count = 0;
    let actualCost = 0;
    let costWithoutTax = 0;
    purchaseItems.map((value) => {
      let ordeItem = Object.create(null);
      //ordeItem["productBean"] = value[13].info.productBean;
      ordeItem["productId"] = value[13].info.productBean.id;
      ordeItem["productName"] = value[1].v;
      ordeItem["unitType"] = value[2].v;
      ordeItem["quantity"] = value[3].v;
      ordeItem["productPricingId"] = null;
      ordeItem["actualCost"] = value[5].v;
      ordeItem["taxTypeValue"] = value[9].v.id;
      ordeItem["taxTypeText"] = value[9].v.name;
      ordeItem["taxPercentage"] = value[8].v;
      ordeItem["taxCost"] = value[10].v;
      ordeItem["netCost"] = value[12].v;
      ordeItem["isSettled"] = true;
      ordeItem["receivedQty"] = value[3].v;
      ordeItem["isIncludeFocQty"] = value[4].v.foc;
      ordeItem["focQty"] = value[4].v.focQty;
      ordeItem["receivedTaxCost"] = value[10].v;
      ordeItem["receivedCostWithoutTax"] = parseFloat(value[11].v);
      ordeItem["receivedNetCost"] = parseFloat(value[12].v);
      ordeItem["lineItemDiscountAmount"] = parseFloat(value[6].v);
      orderItems.push(ordeItem);
      count = count + ordeItem.receivedQty;
      actualCost = actualCost + ordeItem.receivedNetCost;
      costWithoutTax += ordeItem.receivedCostWithoutTax;
    });
    saveObject["itemCount"] = count;
    saveObject["actualCost"] = actualCost;
    saveObject["totalExpectedCost"] = actualCost;
    saveObject["taxTypeValue"] = taxType.id;
    saveObject["taxTypeText"] = taxType.name;
    saveObject["orderItems"] = orderItems;
    saveObject["returnFlag"] = returnFlag;

    if (status == "SETTLED") {
      if (
        invoiceCheckRequired &&
        (!summary.finalAmountExTax || parseFloat(summary.finalAmountExTax) <= 0)
      ) {
        props.showMessage("error", "Invalid Total Amount");
        return null;
      }

      if (summary.discount && parseFloat(summary.discount) != 0) {
        if (
          parseFloat(summary.finalAmount) < 0 &&
          parseFloat(summary.discount) > 0
        ) {
          props.showMessage(
            "error",
            "Validation failed! Can not give more discount than Invoice Amount"
          );
          return null;
        }
      }
    }

    saveObject["totalAmountWithoutTax"] = summary.totalWoTax;
    saveObject["totalTaxAmount"] = summary.totalTax;
    saveObject["totalAmountWithTax"] = summary.total;
    saveObject["amount"] = amount;
    saveObject["roundoffAmount"] = roundoffAmount;
    saveObject["subTotalDiscountAmount"] = summary.discount;
    saveObject["discountTypeText"] = summary.discountType.name;
    saveObject["discountTypeValue"] = summary.discountType.id;

    if (
      summary.finalAmountExTax != null &&
      parseFloat(summary.finalAmountExTax) != 0
    ) {
      saveObject["invoiceAmount"] = StringUtils.formattedNumber(
        summary.finalAmountExTax,
        props.context.store.currencyDecimal
      );
    } else {
      saveObject["invoiceAmount"] = StringUtils.formattedNumber(
        actualCost,
        props.context.store.currencyDecimal
      );
    }

    /*let calculatedShippingCost = 0;
    let shippingCostAccountBeanList = [];
    costAccountMappingList.map((value) => {
      let ordeItem = Object.create(null);
      //ordeItem["fromAccountLedgerId"] = value.accountLedger.id;
      // ordeItem["fromAccountLedgerName"] = value.accountLedger.name;
      ordeItem["toAccountLedgerId"] = value.vendorAccount.id;
      ordeItem["toAccountLedgerName"] = value.vendorAccount.name;
      ordeItem["invoiceNumber"] = value.invoiceNumber;
      ordeItem["shippingCost"] = value.shippingAmount;
      ordeItem["taxPercentage"] = value.taxPercentage;
      ordeItem["date"] = value.date;
      ordeItem["description"] = value.description;
      shippingCostAccountBeanList.push(ordeItem);
      calculatedShippingCost += value.shippingAmount
        ? parseFloat(value.shippingAmount)
        : 0;
    });
    let savedShippingCost = StringUtils.formattedNumber(
      shippingCost ? shippingCost : 0,
      props.context.store.currencyDecimal
    );

    if (
      shippingCost &&
      calculatedShippingCost === parseFloat(savedShippingCost)
    ) {
      saveObject["shippingCost"] = savedShippingCost;
      saveObject["shippingCostAccountBeanList"] = shippingCostAccountBeanList;
    } else if (purchaseOrderObj) {
      saveObject["shippingCost"] = purchaseOrderObj.shippingCost
        ? purchaseOrderObj.shippingCost
        : 0;
      saveObject["shippingCostAccountBeanList"] =
        purchaseOrderObj.shippingCostAccountBeanList;
    }*/

    saveObject["orderType"] = purchaseOrderObj
      ? purchaseOrderObj.orderType
      : returnFlag == true
      ? "GRV"
      : "GRN";

    saveObject["costCalculationTypeName"] = costCalculationType.name;
    saveObject["costCalculationTypeId"] = costCalculationType.id;
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    if (mode == "edit") {
      saveObject["id"] = purchaseOrderObj.id;
      saveObject["intVersion"] = purchaseOrderObj.intVersion;
    }
    return saveObject;
  }

  async function onYesNoClicked(context, value, confirmContextType) {
    setConfirmOpen(false);
    if (value == "yes") {
      if (confirmContextType == "SAVE") {
        var payload = createPayload("SETTLED");
        if (payload) {
          try {
            showProgress(true, "Saving");
            let result = await API.post("/api/v1/purchaseorder", payload);
            props.showMessage(
              "success",
              translate("Purchase order settled sucessfully")
            );
            props.onRefresh();
            if (returnFlag)
              localStorage.removeItem("purchaseReturnOrderLineItems");
            else localStorage.removeItem("purchaseOrderLineItems");

            showQuickPurchaseRequestWindow(result.data.id, "View", returnFlag);
            showProgress(false, "Saving");
          } catch (err) {
            showProgress(false, "Saving");
            if (err.response && err.response.status == 412) {
              showDetailedError(err.response.data);
            } else {
              props.showMessage(
                "error",
                translate("Not able to settle Purchase Order")
              );
            }
          }
        }
      } else if (confirmContextType == "DELETE") {
        try {
          let result = await API.delete(
            "/api/v1/purchaseorder/" + purchaseOrderObj.id
          );
          props.showMessage("warning", translate("Purchase order got removed"));
          setOpenWindow(false);
          props.onRefresh();
        } catch (err) {
          console.log("error", err);
          props.showMessage(
            "error",
            translate("Not able to delete purchase order")
          );
        }
      }
    }
  }

  function onDelete() {
    setConfirmContext({
      title: "Are You Sure",
      message: "Are you sure to delete the order,This action can't revert!",
      type: "warning",
      open: true,
      yes: true,
      no: true,
      confirmContextType: "DELETE",
    });
    setConfirmOpen(true);
  }

  function setPurchaseItemsWrapper(poItems) {
    setPurchaseItems(poItems);
    updateSummary(poItems, summary);
  }

  function updateSummary(poItems, pSummary) {
    console.log("## updateSummary", poItems);

    let s = {
      qty: 0,
      total: 0,
      totalWoTax: 0,
      totalTax: 0,

      finalAmount: 0,
      finalAmountExTax: 0,
      finalTax: 0,
    };

    let total = 0;
    poItems.map((value) => {
      total = total + parseFloat(value[12].v ? value[12].v : 0);
    });

    poItems.map((value) => {
      s.qty += parseFloat(value[3].v ? value[3].v : 0);
      console.log("## QTY", value[3].v ? value[3].v : 0);
      s.totalTax += parseFloat(value[10].v ? value[10].v : 0);
      s.totalWoTax += parseFloat(value[11].v ? value[11].v : 0);
      s.total += parseFloat(value[12].v ? value[12].v : 0);

      let distributionRatio = parseFloat(value[12].v ? value[12].v : 0) / total;

      let fCost = parseFloat(value[12].v ? value[12].v : 0);
      let fTax = parseFloat(value[10].v ? value[10].v : 0);
      let fCostWoTax = parseFloat(value[11].v ? value[11].v : 0);
      if (pSummary.discount && parseFloat(pSummary.discount) > 0) {
        if (pSummary.discountType.id == "1") {
          fCost = fCost - parseFloat(pSummary.discount) * distributionRatio;
          fCostWoTax = fCost / (1 + parseFloat(value[8].v) / 100);
          fTax = fCost - fCostWoTax;
        }
        if (pSummary.discountType.id == "2") {
          //Before Tax
          fCostWoTax =
            fCostWoTax - parseFloat(pSummary.discount) * distributionRatio;
          fTax = (fCostWoTax * parseFloat(value[8].v)) / 100;
          fCost = fCostWoTax + fTax;
        }
      }
      s.finalAmount += fCost;
      s.finalAmountExTax += fCostWoTax;
      s.finalTax += fTax;
    });

    let sum = { ...summary };
    sum.qty = s.qty;
    sum.total = StringUtils.formattedNumberWithStoreDecimal(
      s.total,
      props.context
    );
    sum.totalWoTax = StringUtils.formattedNumberWithStoreDecimal(
      s.totalWoTax,
      props.context
    );
    sum.totalTax = StringUtils.formattedNumberWithStoreDecimal(
      s.totalTax,
      props.context
    );

    sum.finalAmount = StringUtils.formattedNumberWithStoreDecimal(
      s.finalAmount,
      props.context
    );
    sum.finalAmountExTax = StringUtils.formattedNumberWithStoreDecimal(
      s.finalAmountExTax,
      props.context
    );
    sum.finalTax = StringUtils.formattedNumberWithStoreDecimal(
      s.finalTax,
      props.context
    );
    sum.discount = pSummary.discount;
    sum.discountType = pSummary.discountType;

    setSummary(sum);
    setAmount(sum.finalAmount);
  }

  function updateSummaryValue(key, value) {
    console.log(key, value);
    let sum = { ...summary };
    if (key == "discount") {
      sum.discount = value;
    }
    if (key == "discountType") {
      sum.discountType = value;
    }
    updateSummary(purchaseItems, sum);
  }

  const content = (
    <Grid container spacing={1}>
      <Grid item xs={12} sm={12}>
        <QuickPurchaseRequestOrderDetails
          biRef={biRef}
          purchaseOrderObj={purchaseOrderObj}
          setSelectedVendor={setSelectedVendor}
          showMessage={props.showMessage}
        ></QuickPurchaseRequestOrderDetails>
      </Grid>
      <Grid item xs={12} sm={12}>
        <QuickPurchaseRequestList
          data={purchaseItems}
          viewMode={mode}
          updatePurchaseItemData={setPurchaseItemsWrapper}
          biRef={biRef}
          taxType={taxType}
          setTaxType={setTaxType}
          taxTypeOptions={taxTypeOptions}
          showMessage={props.showMessage}
          isReturn={returnFlag}
          costCalculationType={costCalculationType}
          setCostCalculationType={setCostCalculationType}
          costCalculationTypeOptions={costCalculationTypeOptions}
          context={props.context}
          productCache={props.productCache}
        ></QuickPurchaseRequestList>
      </Grid>
      <Grid item xs={12} sm={12}>
        <QuickPurchaseRequestSummary
          taxType={taxType}
          purchaseItems={purchaseItems}
          discountTypeOptions={discountTypeOptions}
          showMessage={props.showMessage}
          //costAccountMappingList={costAccountMappingList}
          //setCostAccountMappingList={setCostAccountMappingList}
          mode={mode}
          selectedVendor={selectedVendor}
          context={props.context}
          summary={summary}
          setSummary={setSummary}
          updateSummaryValue={updateSummaryValue}
          amount={amount}
          setAmount={setAmount}
          roundoffAmount={roundoffAmount}
          errorAmount={errorAmount}
        ></QuickPurchaseRequestSummary>
      </Grid>
    </Grid>
  );

  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"lg"}
          fullWidth={true}
          fullScreen={true}
          open={true}
          onCloseWindow={onCloseWindow}
          onSave={onSave}
          saveLabel="POST"
          onDelete={
            props.context.privileges.grn_grv_delete &&
            props.selectedRowStatus === "DRAFT"
              ? onDelete
              : false
          }
          mode={mode}
          isDataChanged={isDataChanged}
          showSaveDraftButton={
            (!props.context.privileges.grn_grv_draft_edit &&
              props.selectedRowStatus === "DRAFT") ||
            (!props.context.privileges.grn_grv_requested_edit &&
              props.selectedRowStatus === "REQUESTED") ||
            (!props.context.privileges.grn_grv_settled_edit &&
              props.selectedRowStatus === "SETTLED") ||
            mode == "view"
              ? mode === "create"
                ? true
                : false
              : true
          }
          onSaveDraftClicked={onSaveDraftClicked}
          hideSave={
            (!props.context.privileges.grn_grv_draft_edit &&
              props.selectedRowStatus === "DRAFT") ||
            (!props.context.privileges.grn_grv_requested_edit &&
              props.selectedRowStatus === "REQUESTED") ||
            (!props.context.privileges.grn_grv_settled_edit &&
              props.selectedRowStatus === "SETTLED") ||
            mode === "view"
              ? mode === "create"
                ? false
                : true
              : false
          }
        ></PDialog>
      )}
      {showProgressDialog && (
        <PDialog
          content={
            <Grid container style={{ width: 200, margin: 20 }}>
              <Grid item xs={12}>
                <CircularProgress disableShrink /> {progressMessage}
              </Grid>
            </Grid>
          }
          open={true}
          borderLess={true}
        ></PDialog>
      )}
      {confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )}
    </div>
  );
}
